import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { useParams } from 'react-router-dom';
import { useApi } from "app/api/APIProvider";
import { PolicyCard } from 'entities/PolicyCard';
import { PolicyCardTheme } from 'entities/PolicyCard/PolicyCard';
import { policyData } from '../api/policyData';
import {Text, TextSize} from "shared/ui/Text/Text";
import { useEffect, useState } from 'react';
import cls from './PolicyPage.module.scss';
import logo from "shared/assets/img/sber_logo.png";
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { PolicyCondition } from 'entities/PolicyCard/ui/PolicyCondition/PolicyCondition';
import PlayIcon from 'shared/assets/icons/playIcon.svg';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';

export const PolicyPage = () => {
    const api = useApi();
    const { name } = useParams();
    const { banner, cards, form, table, hideForm } = policyData[name];
    const [isBought, setIsBought] = useState(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const isCredit = sessionStorage.getItem('credit') === '1' ? true : false;

    const getFinanceInfo = async () => {
        const products = await api.GetFinanceInfo();
        //@ts-ignore
        setIsBought(products[banner.unique_key].status);
        setIsLoaded(true);
    }

    const cancelIssued = () => {
        setIsBought(!isBought)
    };

    useEffect(() => {
        getFinanceInfo();
    }, []);

    if (!isLoaded) return <PageLoader />
    return (
        <div className={cls.page}>
            <Wrapper className={cls.mainWrapper}>
                <PolicyCard banner={banner} theme={PolicyCardTheme.banner} isPaid={banner.unique_key === 'credit10' ? isCredit : isBought} callback={cancelIssued} />
                <Text className={cls.title} color="#353850" size={TextSize.text_36}>Как работает программа</Text>
                {cards && <PolicyCard cards={cards} theme={PolicyCardTheme.works} />}
                {table && <PolicyCard table={table} theme={PolicyCardTheme.table} />}
                {(!hideForm && (banner.unique_key === 'credit10' ? !isCredit : !isBought)) && <PolicyCard form={form} theme={PolicyCardTheme.register} callback={cancelIssued} />}
                {/* {
                    form.productKey === 'credit10' && (
                        <>
                            <Text className={cls.title} color="#353850" size={TextSize.text_36}>Как работает программа</Text>
                            <PolicyCondition />
                        </>
                    )
                } */}
                <img src={logo} className={cls.img} alt="Разумные деньги фото №18" />
            </Wrapper>
            <AppLink to="/plot" className={cls.backToGameButton}>
                <Button
                    theme={ButtonTheme.BACK_TO_GAME}
                    icon={<PlayIcon />}
                    >
                    Продолжить сюжет
                </Button>
            </AppLink>
        </div>
    );
};
